import { AlertTriangle, X } from 'lucide-react';

interface ConfirmDeleteSocialPostModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  platform: string;
}

export function ConfirmDeleteSocialPostModal({
  isOpen,
  onClose,
  onConfirm,
  platform
}: ConfirmDeleteSocialPostModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <div className="relative w-full max-w-md bg-white rounded-2xl shadow-2xl overflow-hidden">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-2 rounded-lg hover:bg-gray-100 transition-colors"
        >
          <X className="w-5 h-5 text-gray-500" />
        </button>

        <div className="p-6">
          <div className="flex items-center gap-4 mb-4">
            <div className="flex-shrink-0 w-12 h-12 rounded-full bg-red-100 flex items-center justify-center">
              <AlertTriangle className="w-6 h-6 text-red-600" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-[#231F20]">
                Post verwijderen?
              </h3>
              <p className="text-sm text-gray-600 mt-0.5">
                Deze actie kan niet ongedaan gemaakt worden
              </p>
            </div>
          </div>

          <p className="text-sm text-gray-700 mb-6">
            Weet je zeker dat je deze {platform} post wilt verwijderen? Alle data van deze post gaat permanent verloren.
          </p>

          <div className="flex gap-3">
            <button
              onClick={onClose}
              className="flex-1 px-4 py-2.5 border-2 border-gray-300 text-gray-700 bg-white rounded-lg font-medium hover:bg-gray-50 transition-colors"
            >
              Annuleren
            </button>
            <button
              onClick={() => {
                onConfirm();
                onClose();
              }}
              className="flex-1 px-4 py-2.5 bg-red-600 text-white rounded-lg font-medium hover:bg-red-700 transition-colors"
            >
              Verwijderen
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
